<template>
  <div>
    <div class="card p-3">
      <!-- Filter over data -->
      <div class="row">
        <div class="col-md-3">
          <b-form-group class="mb-3" label="tag_type" label-for="tag_type">
            <template slot="label"> Tag type </template>
            <b-form-select
              class="form-select"
              id="language"
              placeholder="Select tag type"
              v-model="selectedTag"
              :options="TagOptions"
              @change="getTagList()"
            >
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group class="mb-3" label="page_name" label-for="tag_type">
            <template slot="label"> Page Name</template>
            <b-form-select
              class="form-select"
              id="language"
              placeholder="Select Page name"
              v-model="selectedPageName"
              :options="pageNameOptions"
              @change="filterTagNameByPageName()"
            >
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group class="mb-3" label="tag_name" label-for="tag_type">
            <template slot="label"> Tag Name</template>
            <b-form-select
              class="form-select"
              id="language"
              placeholder="Select Tag name"
              v-model="selectedTagName"
              :options="tagNameOptions"
              @change="getTagNameBaseDataList()"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <!-- Table to show data -->
      <div class="table-responsive mb-0" v-if="dataToShow.length !== 0">
        <v-table
          class="table table-hover mb-0"
          ref="my-table"
          infinite-scroll-disabled="busy"
          infinite-scroll-distance="10"
          :data="dataToShow"
        >
          <thead class="table-light" slot="head">
            <tr>
              <th>Page Name</th>
              <th v-if="selectedTag == 'text_label'">Sentence</th>
              <th v-for="(lang, index) in languageList" :key="index">
                {{ lang.text }}
              </th>
            </tr>
          </thead>
          <tbody
            class="infinite-list"
            slot="body"
            slot-scope="{ displayData }"
            v-if="!isDataLoading"
          >
            <tr>
              <td class="text-capitalize">
                {{
                  displayData[0]?.data?.kiosk_labal_tag?.tag_name.replaceAll(
                    "_",
                    " "
                  )
                }}
              </td>
              <td v-if="selectedTag == 'text_label'">
                <b-form-input
                  id="page_name"
                  type="text"
                  placeholder="Enter sentence to convert"
                  autocomplete="off"
                  v-model="text_label"
                  @blur="changeToOtherLang()"
                />
              </td>
              <td
                v-for="(data, index) in displayData"
                :key="index"
                class="cursor"
              >
                <template v-if="selectedTag == 'video'">
                  <span v-if="data?.data.video_file">
                    <i
                      class="fas fa-play-circle mx-1"
                      id="video"
                      @click="playVideo(data?.data)"
                    />
                  </span>
                  <span v-else>
                    <b-button
                      variant="outline-primary"
                      class="btn btn-sm"
                      @click="updateTagName(data?.data)"
                    >
                      Upload
                    </b-button>
                  </span>
                </template>
                <template v-else>
                  <div
                    class="overflow-tip"
                    v-if="data?.data?.text_value"
                    @click="updateTagName(data?.data)"
                  >
                    <span>
                      {{ data?.data?.text_value }}
                    </span>
                  </div>
                  <span v-else>
                    <b-button
                      variant="outline-primary"
                      class="btn btn-sm"
                      @click="updateTagName(data?.data)"
                    >
                      Add
                    </b-button>
                  </span>
                </template>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="number in 20" :key="number">
              <td
                class="placeholder-glow"
                v-for="no in languageList.length + 2"
                :key="no"
              >
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody v-if="!isDataLoading && dataToShow.length == 0">
            <tr>
              <td colspan="14" class="text-center">
                <img src="@/assets/images/empty.svg" class="img-fluid" alt="" />
                <p>
                  <span class="text-secondary">No Data Found</span>
                </p>
              </td>
            </tr>
          </tbody>
        </v-table>
      </div>
    </div>
    <!-- Modal is use for update text label and video details-->
    <b-modal
      id="update-data"
      centered
      :title="selectedTag == 'video' ? 'Update video' : 'Update Text Label'"
      title-class="font-18"
      ref="update-data"
      hide-footer
    >
      <div>
        <div class="container">
          <div class="row">
            <div class="col-12">
              <form @submit.prevent="updateData()">
                <div class="form-group" v-if="selectedTag == 'video'">
                  <b-form-file
                    v-model="videoFile"
                    class="form-control"
                    plain
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                  />
                </div>
                <div class="form-group" v-else>
                  <b-form-input
                    id="session_id"
                    type="text"
                    placeholder="Enter text label value"
                    v-model.trim="text_value"
                    autocomplete="off"
                  />
                </div>
              </form>
            </div>
          </div>
          <div class="row">
            <div class="d-flex align-items-center">
              <b-button
                variant="outline-primary"
                class="float-end mt-1 ms-2"
                type="submit"
                @click="updateData()"
                :class="{
                  disabled: isBtnLoading,
                }"
              >
                <i
                  class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                  v-if="isBtnLoading"
                />
                Save
              </b-button>
              <b-button
                variant="outline-primary"
                class="float-end mt-1 ms-2"
                type="submit"
                @click="cancelData()"
              >
                Cancel
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Modal is use for display settle amount -->
    <b-modal
      id="video-player"
      centered
      title-class="font-18"
      ref="video-player"
      hide-footer
      size="lg"
    >
      <template #modal-title>
        <span> Video Player </span>
        <b-button
          variant="outline-primary"
          class="btn btn-sm ms-2"
          @click="changeVideo()"
        >
          Change
        </b-button>
      </template>
      <div>
        <video :src="video" controls width="765" height="500"></video>
      </div>
    </b-modal>
  </div>
</template>
<script>
import kioskMetaService from "@/helpers/APIService/kioskmeta.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import axios from "axios";

export default {
  data() {
    return {
      // Language Related
      languageList: [],
      text_label: "",
      text_value: "",
      video: "",
      videoFile: "",
      updateId: "",
      isBtnLoading: false,
      // Tag Type Related
      TagOptions: [
        { text: "Select Tag type", value: "" },
        { text: "Text Labels", value: "text_label" },
        { text: "Videos", value: "video" },
      ],
      selectedTag: "",
      // Page Name Related
      pageNameOptions: [],
      selectedPageName: "",
      // Tag Name Related
      tagNameList: [],
      tagNameOptions: [],
      selectedTagName: [],
      // Data to show
      isDataLoading: false,
      dataToShow: [],
    };
  },
  mounted() {
    this.getLanguageList();
  },
  methods: {
    // Method is use for get language list
    async getLanguageList() {
      try {
        const response = await kioskMetaService.getLanguages("?is_active=true");
        if (response) {
          response.map((item) => {
            this.languageList.push({
              text: item.language_name,
              value: item.id,
              item,
            });
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is use for get tag name list based on selected tag type
    async getTagList() {
      try {
        this.dataToShow = [];
        this.pageNameOptions = [{ text: "Select Page Name", value: "" }];
        this.selectedPageName = "";
        const response = await kioskMetaService.getTags(
          `?tag_type=${this.selectedTag}`
        );
        if (response) {
          this.tagNameList = response;
          const uniquePageNames = new Set();
          response.forEach((item) => {
            if (item.page_name) {
              uniquePageNames.add(item.page_name);
            }
          });
          const tempArray = Array.from(uniquePageNames);
          tempArray.map((item) => {
            this.pageNameOptions.push({
              text: item.replaceAll("_", " "),
              value: item,
            });
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is use for filter over tag name by selected page name
    filterTagNameByPageName() {
      this.tagNameOptions = [{ text: "Select Tag Name", value: "" }];
      this.selectedTagName = "";
      this.tagNameList.map((item) => {
        if (item.page_name == this.selectedPageName) {
          this.tagNameOptions.push({
            value: item.id,
            text: item.tag_name.replaceAll("_", " "),
          });
        }
      });
    },
    // Method is use for get all language base data list
    getTagNameBaseDataList() {
      this.text_label = "";
      if (this.selectedTag == "text_label") {
        this.getTextLabelList(`?kiosk_labal_tag=${this.selectedTagName}`);
      }
      if (this.selectedTag == "video") {
        this.getVideoList(`?kiosk_labal_tag=${this.selectedTagName}`);
      }
    },
    // Method is use for get text label list
    async getTextLabelList(filter = "") {
      try {
        this.isDataLoading = true;
        const response = await kioskMetaService.getTextLabels(filter);
        if (response) {
          const data = this.createLanguageObjects(response);
          this.dataToShow = data;
          this.isDataLoading = false;
        }
      } catch (error) {
        this.isDataLoading = false;
        errorHandler(error);
      }
    },
    // Method is use for get video list
    async getVideoList(filter = "") {
      try {
        this.isDataLoading = true;
        const response = await kioskMetaService.getVideos(filter);
        if (response) {
          const data = this.createLanguageObjects(response);
          this.dataToShow = data;
          this.isDataLoading = false;
        }
      } catch (error) {
        this.isDataLoading = false;
        errorHandler(error);
      }
    },
    // Method is use for handle data to show
    createLanguageObjects(dataToShow) {
      const languageObjects = this.languageList
        .map((language) => {
          const foundData = dataToShow.find(
            (data) => data.kiosk_language === language.value
          );
          if (foundData) {
            return {
              languageName: language.text,
              data: foundData,
            };
          }
          return null;
        })
        .filter((item) => item !== null);

      return languageObjects;
    },
    // Method is use for update text label and video tag name
    updateTagName(data) {
      this.updateId = data.id;
      if (this.selectedTag == "text_label") {
        this.text_value = data?.text_value;
      }
      this.$bvModal.show("update-data");
    },
    // Method is use for add new text label & video label
    async updateData() {
      if (this.selectedTag == "text_label") {
        try {
          this.isBtnLoading = true;
          const response = await kioskMetaService.updateTextLabel(
            this.updateId,
            {
              text_value: this.text_value,
            }
          );
          if (response.status == false) {
            Middleware.notification(response.message);
            return;
          }
          this.dataToShow = this.dataToShow.map((item) => {
            if (item.data?.kiosk_language == response.kiosk_language) {
              item.data.text_value = response.text_value;
              return item;
            }
            return item;
          });
          this.isBtnLoading = false;
          Middleware.notification("Text label updated successfully", "success");
          this.cancelData();
        } catch (error) {
          this.isBtnLoading = false;
          errorHandler(error);
        }
      } else {
        try {
          this.isBtnLoading = true;
          const formData = new FormData();
          formData.append("video_file", this.videoFile);
          const response = await kioskMetaService.updateVideo(
            this.updateId,
            formData
          );
          if (response.status == false) {
            Middleware.notification(response.message);
            return;
          }
          this.dataToShow = this.dataToShow.map((item) => {
            if (item.data?.kiosk_language == response.kiosk_language) {
              item.data.video_file = response.video_file;
              return item;
            }
            return item;
          });
          Middleware.notification("Video file updated successfully", "success");
          this.cancelData();
          this.isBtnLoading = false;
        } catch (error) {
          this.isBtnLoading = false;
          errorHandler(error);
        }
      }
    },
    // Method is use for cancel text label & video modal and reset data
    cancelData() {
      this.videoFile = "";
      this.text_value = "";
      this.isBtnLoading = false;
      this.$bvModal.hide("update-data");
    },
    // Method is use for change video
    changeVideo() {
      this.video = "";
      this.videoFile = null;
      this.$bvModal.show("update-data");
      this.$bvModal.hide("video-player");
    },
    // Method is use for play video
    playVideo(data) {
      this.updateId = data.id;
      this.video = data?.video_file;
      this.$bvModal.show("video-player");
    },
    // Method is use for convert text into other language
    changeToOtherLang() {
      this.languageList.map(async (item) => {
        const language_code = item.item?.language_code;
        const response = await this.translateText(
          this.text_label,
          language_code
        );
        const updateText = language_code == "en" ? this.text_label : response;
        const findData = this.dataToShow.find(
          (data) => data?.data.kiosk_language == item.value
        );
        await kioskMetaService
          .updateTextLabel(findData?.data.id, {
            text_value: updateText,
          })
          .then((responseData) => {
            this.dataToShow = this.dataToShow.map((item) => {
              if (item.data?.kiosk_language == responseData.kiosk_language) {
                item.data.text_value = responseData.text_value;
                return item;
              }
              return item;
            });
          });
      });
    },
    async translateText(text, targetLanguage) {
      if (targetLanguage !== "en") {
        const apiUrl = "https://api.mymemory.translated.net/get";
        const params = {
          q: text,
          langpair: `en|${targetLanguage}`,
        };

        try {
          const response = await axios.get(apiUrl, { params });
          return response.data.responseData.translatedText;
        } catch (error) {
          console.error("Error translating text:", error);
        }
      }
    },
  },
};
</script>
